import React, { useLayoutEffect, useRef } from 'react';
import { SpinnerStyled } from '../style';
import { Spinner } from '../../Spinner/Spinner';
import {
  ChartTitle,
  ChartTitleMoreInfo,
  ChartTitleText,
} from './GainersAndLosers.style';
import {
  OpenTradingPositionsWrapper,
  OpenTradingPositionsItem,
  CanvasArc,
  ProgressTitle,
  LongsShorts,
  InnerFlex,
  SubText,
  Text,
  Flex,
  OpenTradingPositionsInner,
} from './OpenTradingPositions.style';
import { MobileText, MobileTitle } from '../OrderList/OrderList.style';

const PositionsItem = ({ data }) => {
  const progressCanvas = useRef();
  const progressCanvas_2 = useRef();
  useLayoutEffect(() => {
    createArcs();
  }, []);

  const Longs = +(
    data.volume_long
    / (data.volume_long + data.volume_short)
  ).toFixed(1);
  const Shorts = +(
    data.volume_short
    / (data.volume_long + data.volume_short)
  ).toFixed(1);

  function createArcs() {
    // arc 1
    const canvas = progressCanvas.current;
    const context = canvas.getContext('2d');
    // arc 2
    const canvas_1 = progressCanvas_2.current;
    const context_1 = canvas_1.getContext('2d');

    /**
     * Calculate length for progress bar, longs + shorts make 100% of arc.
     */
    const fullLine = +(Longs + Shorts).toFixed(2);
    // get long and short prcent in fullLine(longs + shorts).
    const longPrecent = (Longs * 100) / fullLine;
    const shortPrecent = (Shorts * 100) / fullLine;

    // get start and end of angle.
    const shortPrecentStartAngle = -+((1 * shortPrecent) / 100).toFixed(1) * Math.PI;
    const shortPrecentEndAngle = 0 * Math.PI;
    const shortPrecentCounterClockwise = false;

    const x = canvas_1.width / 2;
    const y = 80;
    const radius = 76;
    context.beginPath();
    context.arc(
      x,
      y,
      radius,
      shortPrecentStartAngle,
      shortPrecentEndAngle,
      shortPrecentCounterClockwise,
    );
    context.lineWidth = 8;

    // line color
    context.strokeStyle = 'rgba(246, 84, 62, 1)';
    context.stroke();

    // get start and end of angle.
    const longPrecentStartAngle = 1 * Math.PI;
    const longPrecentEndAngle = (1 + (1 * longPrecent) / 100) * Math.PI;
    const longPrecentCounterClockwise = false;

    context_1.beginPath();
    context_1.arc(
      x,
      y,
      radius,
      longPrecentStartAngle,
      longPrecentEndAngle,
      longPrecentCounterClockwise,
    );
    context_1.lineWidth = 8;

    // line color
    context_1.strokeStyle = 'rgba(27, 178, 90, 1)';
    context_1.stroke();
  }

  return (
    <OpenTradingPositionsItem>
      <ProgressTitle>{data.instrument}</ProgressTitle>
      <CanvasArc ref={progressCanvas} width="320px" height="320px" />
      <CanvasArc ref={progressCanvas_2} width="320px" height="320px" />
      <InnerFlex>
        <LongsShorts>
          <div>Longs</div>
          {Longs}
          %
        </LongsShorts>
        <LongsShorts red>
          <div>Shorts</div>
          {Shorts}
          %
        </LongsShorts>
      </InnerFlex>
      <Flex>
        <SubText>Average Buy Price</SubText>
        <SubText>Average Sell Price</SubText>
      </Flex>
      <Flex>
        <Text>{data.average_buy}</Text>
        <Text red>{data.average_sell}</Text>
      </Flex>
    </OpenTradingPositionsItem>
  );
};

const OpenTradingPositions = ({ data }) => (
  <OpenTradingPositionsWrapper>
    <ChartTitle onlyDesktop>
      <ChartTitleText>
        OPEN TRADING POSITIONS
        <ChartTitleMoreInfo>&#105;</ChartTitleMoreInfo>
      </ChartTitleText>
    </ChartTitle>
    <MobileTitle>
      OPEN TRADING
      {' '}
      <b>POSITIONS</b>
    </MobileTitle>
    <MobileText>
      View live forex rates at a glance, keeping you informed on price action
      and enabling consistent trading.
    </MobileText>
    {!data?.length ? (
      <SpinnerStyled>
        <Spinner />
      </SpinnerStyled>
    ) : (
      ''
    )}
    <OpenTradingPositionsInner>
      {data?.length
        ? data
          ?.filter((item) => item?.position_info)
          ?.map((item) => <PositionsItem data={item.position_info || {}} />)
        : ''}
    </OpenTradingPositionsInner>
  </OpenTradingPositionsWrapper>
);

export default OpenTradingPositions;
